// Icons
'use client';
import { IoSearchSharp } from 'react-icons/io5';
import { useNavigationWithLoading } from '@utils/navigation';
export default function HeaderSearch({ decryptedAuth }: { decryptedAuth: any }) {
	const { navigateWithLoading } = useNavigationWithLoading();
	const handleClick = () => {
		navigateWithLoading('/search');
	};

	return (
		<div
			onClick={handleClick}
			className={`bg-[#4444DA] rounded-full w-full max-w-[180px] sm:min-w-[220px]  cursor-text h-8 flex flex-row items-center overflow-hidden justify-between relative mr-2`}>
			<span className={`mx-6 text-[#B9B9FF] text-sm`}>Search</span>
			<div
				className={`flex flex-row items-center justify-center size-8 text-white bg-[#5858F2] rounded-full`}>
				<IoSearchSharp />
			</div>
		</div>
	);
}
